xtend = require 'xtend'
{ currentLocale } = require '@trello/locale'

module.exports = (baseOptions) -> xtend baseOptions, locale: currentLocale
